var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDays4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 48",
    style: {
      enableBackground: "new 0 0 64 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.9363,
    y1: 23.5,
    x2: 62.9363,
    y2: 23.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E21776"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.9,11.2V8.8c0-2-1.6-3.6-3.6-3.6h-6.8v-5.7h-3v5.7H11.7v-5.7h-3v5.7H2.6c-2,0-3.6,1.6-3.6,3.6v5.6h0v28.9 c0,2.2,1.8,4,4.1,4h55.7c2.2,0,4.1-1.8,4.1-4L62.9,11.2L62.9,11.2z M2.6,8.3h6.1v1.4h3V8.3h37.8v1.4h3V8.3h6.8 c0.3,0,0.6,0.2,0.6,0.6v2.4h0v0.3H2.1v-0.3H2.1V8.8C2.1,8.5,2.3,8.3,2.6,8.3z M2.1,23.2h10.7v8.3H2.1V23.2z M15.9,23.2h12.8v8.3 H15.9V23.2z M28.7,14.5v5.7H15.9v-5.7H28.7z M44.6,14.5v5.7H31.7v-5.7H44.6z M28.7,34.5v10H15.9v-10H28.7z M31.7,34.5h12.8v10H31.7 V34.5z M31.7,31.5v-8.3h12.8v8.3H31.7z M47.6,23.2h12.4v8.3H47.6V23.2z M47.6,20.2v-5.7h12.4v5.7H47.6z M12.9,14.5v5.7H2.1v-5.7 H12.9z M2.1,43.4v-8.9h10.7v10H3.2C2.6,44.4,2.1,44,2.1,43.4z M58.9,44.4H47.6v-10h12.4v8.9C59.9,44,59.4,44.4,58.9,44.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDays4);
export default __webpack_public_path__ + "static/media/icon_days4.e9c88329a409fbb892299c2022f2bf47.svg";
export { ForwardRef as ReactComponent };